import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProductSite from "@/components/ProductSite";
import { LanguageProvider } from "@/lib/i18n";

const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const PaymentCancel = lazy(() => import("@/pages/PaymentCancel"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const DeleteAccount = lazy(() => import("@/pages/DeleteAccount"));
const UserGuide = lazy(() => import("@/pages/UserGuide"));
const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const MarketingKit = lazy(() => import("@/pages/MarketingKit"));

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center text-sm text-gray-400">Loading...</div>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<ProductSite bot="kirana" />} />
          <Route path="/kirana" element={<ProductSite bot="kirana" />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/guide" element={<UserGuide />} />
          <Route path="/pricing" element={<Navigate to="/#pricing" replace />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/marketing" element={<MarketingKit />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
